import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import GroupIcon from '@mui/icons-material/Group';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ContactsIcon from '@mui/icons-material/Contacts';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import { Category, PriceChange, Chat } from '@mui/icons-material';

// Main navigation
export const navItemsData = [
    { iconId: "3d-drawings", text: "3D Drawings", link: '/3d-drawings', icon: <Category/> },
    { iconId: "custom-status-up", text: "Dashboard", link: '/dashboard', icon: <DashboardCustomizeIcon/> },
    { iconId: "opportunities", text: "Opportunities", link: '/opportunities', icon: <AccountTreeIcon/> },
    { icodId: "scheduling", text: "Shipping Calendar", link: "/schedule", icon: <WorkHistoryIcon/> },
    { iconId: "reporting", text: "Reporting & Modules", link: "/reporting", icon: <AnalyticsIcon/> },
    { iconId: "customers", text: "Customers", link: "/customers", icon: <RecentActorsIcon/> },
    { iconId: "contacts", text: "Contacts", link: "/contacts", icon: <ContactsIcon/> },
    { iconId: "catalogs", text: "Catalogs", link: "/catalogs", icon: <Category/> },
    { iconId: "base-quoting", text: "Quoting", link: "/base-quoting", icon: <PriceChange/> },
    { iconId: "users", text: "Users", link: "/users", icon: <GroupIcon/> },
    { iconId: "base-chat", text: "Chat", disabled: true, disabledTooltip: "To enable Chat feature contact your system administrator", icon: <Chat/> },
];

export const tagOptions = [
    // Material handling
    { value: "rcu", label: "Rail Car Unload" },
    { value: "fvt", label: "Vacuum Takeoff Kit" },
    { value: "cc-kit", label: "Pressure Convey Kit (CC-KIT)" },        
    // Blending
    { value: "monolayer", label: "Mono Layer" },
    { value: "coex", label: "Coex" },
    { value: "3-layer", label: "3-Layer" },
    { value: "4-layer", label: "4-Layer" },    
    { value: "5-layer", label: "5-Layer" },
    { value: "7-layer", label: "7-layer" },
    { value: "9-layer", label: "9-layer" },
    { value: "auto-clean", label: "Auto Clean" },
    // Other
    { value: "rate-control", label: "Rate Control" },
    { value: "smart-stand", label: "Smart Stand" },
    { value: "silo", label: "Silo" },
    { value: "daybin", label: "Daybin" },
    { value: "box-tilt", label: "Box Tilt" }, 
    { value: "auto-aspirator", label: "Auto Aspirator" },    
    { value: "cleanout", label: "Cleanout Station" },   
    { value: "cyclone", label: "Cyclone" },     
    { value: "auger-feeder", label: "Auger Feeder" },
    { value: "mezz", label: "Mezzanine" },
    
    // Controls
    { value: "allen-bradley", label: "Allen Bradley" },
    { value: "beckhoff", label: "Beckhoff" }, 
    // PJ Additions
    { value: "project-addition", label: "Project Addition" },  
    // Pumps?
    { value: "tranquility", label: "Tranquility Pump" },
    { value: "standard-pump", label: "Standard Pump" },   
    { value: "pressure-pump", label: "Pressure Pump" },             
    // Sasquatch
    { value: "sasquatch", label: "Sasquatch" },   
    
    // TM Equipment
    { value: "dryer", label: "Dryer" },
    { value: "multi-hopper", label: "Multi Hopper" },
    { value: "tm-pump", label: "MK Series TM Pump" },            
];

// Application Docs
// Table with: name, link, date updated, type (or tag)
// Terms, /link-to-terms.doc, 7/2/2025, Quoting

// Additional Notes, /link-to-additional-notes.doc, 7/2/2025, Quoting
// Sizing Pumps, /link-to-sizing-pumps.doc, 7/2/2025, Quoting
// Updating QuoteWerks Catalog, /link.doc, 7/2/2025, Quoting
// Weekly Quote Report, /link.doc, 7/2/2025, Quoting
// Vacuum Pump SCFM Requirements, /link.doc, 7/2/2025, Technical
